module.exports = __webpack_public_path__ + "5c992412585f055f88737f09e6243eb8.png";